
<template>
    <div ref="listWrap">
        <wrapper-list
                @add="paasAddPage"
                @calculate="paasCalculate"
                ref="wrapperList" >
            <Form class="list-query-wrap" slot="query" :model="queryParam" :label-width="defaultLabelWidth" ref="queryForm">
                <row class="list-query-row">
                    <FormItem label="名称" class="list-query-item">
                        <Input  v-model="queryParam.query_LIKE_title" placeholder=""
                                @on-change="queryTableDatas" clearable />
                    </FormItem>
                    <FormItem label="类型" class="list-query-item">
                        <Enum :enumJsonKey="'crmdict-couponType'"  v-model="queryParam.query_EQ_couponType"
                              @on-change="queryTableDatas" />
                        </Enum>
                    </FormItem>
                </row>
            </Form>
            <Table slot="table" stripe border :height="tableHeight"
                   :data="tableData"
                   :columns="tableColumns"
                   @on-selection-change="selectTableDataChange"
                   @on-sort-change="sortTableData"
                   :no-data-text="noDataText">
            </Table>
            <Page slot="page"  :total="totalRecords"
                  show-total show-sizer
                  @on-change="changePage"
                  @on-page-size-change="changePageSize">
            </Page>
        </wrapper-list>
    </div>
</template>
<script>
    import wrapperList from "@/components/paas/wrapper-list";
    import metaList from "@/assets/js/list/meta-list.js";
    import CellBar from '@/components/paas/cell-bar' //列表内操作
    import EnumShow from "@/components/paas/enum-show";  //如果有枚举，需要引入
    import Enum from '@/components/paas/query-enum' //枚举查询
    export default {
        name: "list",
        mixins: [ metaList ],
        components: { wrapperList ,CellBar,EnumShow,Enum},
        data() {
            return {
                serviceUrl:"/member/coupon",  //每个页面访问后台服务器的路径
                currentIdFiledName: 'id',
                queryParam:{
                    query_LIKE_name:"",
                    query_EQ_couponType:""
                },
                defaultLabelWidth:200,
                tableColumns:[
                    {
                        type: 'index',  //type: 'index'，可以排序
                        width: 40,
                        align: 'center',
                    },
                    {
                        title: '优惠券类型',
                        key: 'couponType',
                        width:100,
                        render:(h,params)=>{
                            return h(EnumShow,{
                                props:{
                                    enumGroupCode:'crmdict',
                                    enumCode:'couponType',
                                    value:params.row.couponType
                                }
                            })
                        }
                    },
                    {
                        title: '优惠券名称',
                        key: 'name',
                    },
                    {
                        title: '优惠券面值',
                        key: 'couponPrice',
                        width:100,
                    },
                    {
                        title: '最低消费',
                        key: 'useMinPrice',
                        width:100,
                    },
                    {
                        title: '领取有效期限',
                        key: 'couponStartTime',
                        render:(h,params)=>{
                            console.log(params.row.couponStartTime);
                            console.log(params.row.couponEndTime);
                            return h("div",[
                                h("span",{},params.row.couponStartTime),
                                h("span",{}," 至 "),
                                h("span",{},params.row.couponEndTime),
                            ])
                        }
                    },
                    {
                        title: '每人限领取',
                        key: 'atMost',
                        width:100,
                    },
                    {
                        title: '操作',
                        render: (h, params) => {
                            return h(CellBar,
                                {
                                    props:{
                                        show:'textIcon'  //操作也显示标准按钮的样式（text、icon、textIcon）
                                    },
                                    //自定义事件监听器“on”,不支持如v-on:keyup.enter的修饰符，需要手动匹配keyCode
                                    on: {
                                        // 子组件$emit传递函数,必须是箭头函数写法
                                        'edit': ()=> {
                                            this.$nextTick(()=>{
                                                this.paasEditOper(params.row[this.currentIdFiledName]);
                                            })
                                        },
                                        'delete':()=>{
                                            this.$nextTick(()=>{
                                                this.paasDeleteOper(params.row[this.currentIdFiledName]);
                                            })
                                        },
                                        'detail':()=>{
                                            this.$nextTick(()=>{
                                                this.paasDetailOper(params.row[this.currentIdFiledName]);
                                            })
                                        }
                                    }
                                }
                            )
                        }
                    }
                ],
            }
        },
        mounted(){
        },
        methods:{
        }
    }
</script>
